import React, { useState, useEffect } from "react";
import { FormGroup, Label, Col, Form, Input } from "reactstrap";
import * as Styled from "./PersonalDataForm.styles";
import { connect } from "react-redux";
import { updateProfile } from "../../../../redux/actions/user/userProfile.actions";
import l10n from "../../../../localization";

function PersonalDataForm(props) {
  const INITIAL_USER_VALIDATION = {
    name: "",
    userType: "",
    address: "",
    post: "",
    postCode: "",
    email: "",
    vatId: "",
    userCode: ""
  };

  const [user, setUser] = useState({ ...INITIAL_USER_VALIDATION });

  useEffect(() => {
    setUser({
      name: props.user.userData.data.name,
      userType: props.user.userData.data.userType,
      address: props.user.userData.data.address,
      post: props.user.userData.data.post,
      postCode: props.user.userData.data.postCode,
      email: props.user.userData.data.email,
      vatId: props.user.userData.data.vatId,
      userCode: props.user.userData.data.userCode
    });
  }, [props.user.userData]);

  return (
    <Styled.Card>
      <Styled.Header>{l10n.profile.personalData}</Styled.Header>
      <Styled.Body>
        <Form>
          <FormGroup row className="d-flex align-items-baseline">
            <Col md={2}>
              <Label for="name">{l10n.profile.name}</Label>
            </Col>
            <Col md={10}>
              <Input
                type="text"
                name="name"
                id="name"
                value={user.name}
                disabled
              />
            </Col>
          </FormGroup>

          <FormGroup row className="d-flex align-items-baseline">
            <Col md={2}>
              <Label for="userType">{l10n.profile.userType}</Label>
            </Col>
            <Col md={10}>
              <Input
                type="text"
                name="userType"
                id="userType"
                value={user.userType}
                disabled
              />
            </Col>
          </FormGroup>

          <FormGroup row className="d-flex align-items-baseline">
            <Col md={2}>
              <Label for="address">{l10n.profile.address}</Label>
            </Col>
            <Col md={10}>
              <Input
                type="text"
                name="address"
                id="address"
                value={user.address}
                disabled
              />
            </Col>
          </FormGroup>

          <FormGroup row className="d-flex align-items-baseline">
            <Col md={2}>
              <Label for="post">{l10n.profile.post}</Label>
            </Col>
            <Col md={10}>
              <Input
                type="text"
                name="post"
                id="post"
                value={`${user.post || ""} ${user.postCode || ""}`}
                disabled
              />
            </Col>
          </FormGroup>

          <FormGroup row className="d-flex align-items-baseline">
            <Col md={2}>
              <Label for="email">{l10n.profile.email}</Label>
            </Col>
            <Col md={10}>
              <Input
                type="email"
                name="email"
                id="email"
                value={user.email}
                disabled
              />
            </Col>
          </FormGroup>

          <FormGroup row className="d-flex align-items-baseline">
            <Col md={2}>
              <Label for="vatId">{l10n.profile.vatId}</Label>
            </Col>
            <Col md={10}>
              <Input
                type="text"
                name="vatId"
                id="vatId"
                value={user.vatId}
                disabled
              />
            </Col>
          </FormGroup>

          <FormGroup row className="d-flex align-items-baseline">
            <Col md={2}>
              <Label for="userCode">{l10n.profile.userCode}</Label>
            </Col>
            <Col md={10}>
              <Input
                type="text"
                name="userCode"
                id="userCode"
                value={user.userCode || ""}
                disabled
              />
            </Col>
          </FormGroup>
        </Form>
      </Styled.Body>
    </Styled.Card>
  );
}

export default connect(({ user }) => ({ user }), { updateProfile })(
  PersonalDataForm
);
